import { FC } from "react";
import { useDidMount, useWillUnmount } from "rooks";
import Stack from "@mui/material/Stack";
import { WorkflowsDataGrid } from "./components/WorkflowsDataGrid";
import { WorkflowsEmptyState } from "./components/WorkflowsEmptyState";
import { useAppDispatch, useAppSelector } from "../../../../../store/hooks";
import { workflowsExistSelector } from "../../../../../store/automations/selectros/workflow/list-data/workflowsExistSelector";
import { getWorkflowsThunk } from "../../../../../store/automations/thunks/wokrflows/getWorkflowsThunk";
import { resetAutomationsState } from "../../../../../store/automations/automationsSlice";
import { workflowsDataLoadingSelector } from "../../../../../store/automations/selectros/workflow/list-data/workflowsDataLoadingSelector";
import { workflowsDataUninitializedSelector } from "../../../../../store/automations/selectros/workflow/list-data/workflowsDataUninitializedSelector";

export const WorkflowsPage: FC = () => {
  const dispatch = useAppDispatch();
  const exist = useAppSelector(workflowsExistSelector);
  const loading = useAppSelector(workflowsDataLoadingSelector);
  const uninitialized = useAppSelector(workflowsDataUninitializedSelector);

  useDidMount(() => {
    dispatch(getWorkflowsThunk());
  });

  useWillUnmount(() => {
    dispatch(resetAutomationsState());
  });

  return (
    <Stack bgcolor="white" height="100%">
      {!uninitialized &&
        (!loading && !exist ? <WorkflowsEmptyState /> : <WorkflowsDataGrid />)}
    </Stack>
  );
};
